import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { finalize } from 'rxjs';
import { AliasService } from '../../services/alias.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-delete-document',
  standalone: true,
  templateUrl: './delete-document.component.html',
  styleUrls: ['./delete-document.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule
  ]
})
export class DeleteDocumentComponent implements OnInit {

  constructor(
    private readonly fb: FormBuilder,
    private readonly aliasService: AliasService,
    private readonly snackBar: MatSnackBar,
    private readonly auth: AuthenticationService
  ) {}

  formData!: FormGroup;
  isDeleting = false;

  // http o https obbligatorio
  urlPattern = /^https?:\/\/.*$/;

  ngOnInit(): void {
    this.formData = this.fb.group({
      inputUrlsArray: this.fb.array([])
    });

    this.aggiungiUrl();
  }

  get inputUrls(): FormArray {
    return this.formData.get('inputUrlsArray') as FormArray;
  }

  aggiungiUrl(): void {
    const urlGroup = this.fb.group({
      documentUrl: ['', [Validators.required, Validators.pattern(this.urlPattern)]]
    });
    this.inputUrls.push(urlGroup);
  }

  removeUrl(index: number): void {
    this.inputUrls.removeAt(index);
  }

  cancellaDocumenti(): void {
    if (this.formData.valid) {
      const urls = this.formData.value.inputUrlsArray.map((u: any) => u.documentUrl);
      this.isDeleting = true;

      this.aliasService.deleteDocuments(urls).pipe(
        finalize(() => {
          this.isDeleting = false;
        })
      ).subscribe({
        next: () => {
          this.snackBar.open(`Eliminazione del documento completata con successo`, 'Chiudi', {
            duration: 3000,
            panelClass: ['snackbar-success']
          });
          this.inputUrls.clear();
          this.aggiungiUrl();
        },
        error: (err) => {
          console.log('Errore durante il processo di eliminazione', err);
          this.snackBar.open(`Si è verificato un errore. Il documento non è stato eliminato.`, 'Chiudi', {
            duration: 3000,
            panelClass: ['snackbar-error']
          });
        }
      });
    }
  }

  canDoActions(role: string): boolean {
    return this.auth.hasRole(role);
  }
}